import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '@/store';
import { UserAboutData } from '@/api/users/userAbout';

interface UserAboutState {
  userAboutData: UserAboutData | null;
}

const initialState: UserAboutState = {
  userAboutData: null
};

const userAboutSlice = createSlice({
  name: 'userAbout',
  initialState: initialState,
  reducers: {
    setUserAboutData: (state, action: PayloadAction<UserAboutData | null>) => {
      state.userAboutData = action.payload;
    }
  }
});

export const { setUserAboutData } = userAboutSlice.actions;

export const selectUserAboutData = (state: RootState) => {
  return state.userAbout.userAboutData;
};

export const userAboutReducer = userAboutSlice.reducer;
